import { css } from '@/styled-system/css';

export const tooltipArrowStyles = css.raw({
  fill: 'Tooltip.neutral.bg',
});
